var validateContactUsForm = function () {
	const forms = new forms4i();
	const helpers = new formHelpers4i();
	const contactForm = document.getElementById("contactUsForm");
	const submitBtn = document.getElementById("btnContactUsSubmit");
	const successSection = document.getElementById("submitSuccess");
	const specificSite = window.location.href.includes("outlet.4imprint.com") || window.location.href.includes("outlet-sandbox.4imprint.com") || window.location.href.includes("outletcore-dev.4imprint.com") || window.location.href.includes("www.4imprint.") || window.location.href.includes("sandboxmain.4imprint.") || window.location.href.includes("localhost:7274/");
	const messages = {
		Failure: "There was an error submitting your information. Please refresh the page and try again."
	};
	
	const init = () => {
		if (submitBtn) submitBtn.addEventListener("click", validateForm);
	};
	
	const validateForm = (e) => {
		e.preventDefault();
		forms.formValidation(contactForm, submitContactUs, e, helpers.ClearBusyBtn);
	};
	
	const submitContactUs = async () => {	
		helpers.ClearStatus();
		helpers.ShowBusyBtn(submitBtn);
		submitBtn.disabled = true;
		
		// Check if grecaptcha is defined
		// if not, try to fetch the script again 
		if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
		
		// need to show an error if recaptcha script still isn't available
		if(typeof grecaptcha == "undefined"){
			failure();
		}else{
			grecaptcha.execute(helpers.RecaptchaKey, { action: helpers.RecaptchaName })
				.then(function(token) {
					const data = {
						Email: document.getElementById("Email").value,
						EmailBody: document.getElementById("EmailBody").value,
						RecaptchaActionName: helpers.RecaptchaName,
						RecaptchaToken: token
					};
					
					submitContactInfo(data);
				});
		}
	};
	
	const getVerification = () => {
		let verification = helpers.HeaderToken;
		if (verification == "") verification = contactForm.querySelector('input').value;
		let header = { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "__RequestVerificationToken": verification };
		
		return header;
	};
	
	const submitContactInfo = async (data) => {
		let headers;
		if(specificSite) headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": helpers.HeaderToken };
		else headers = getVerification();
		
		let responseJSON;
		try{
			const response = await fetch('/info/submitcontactus', {
				method: 'POST', 
				body: JSON.stringify(data), 
				headers: headers
			});
			if(!response.ok) throw new Error(`Error processing contact form request: ${response.statusText}`);
			responseJSON = await response.json();
		}catch(error){
			console.error(error);
			failure();
		}
		
		if(responseJSON){
			if (!responseJSON.modelStateInvalid) {
				if(responseJSON.success) showSuccess(responseJSON.message);
				else showError(responseJSON.message);
			}else {
	    			contactForm.querySelector(".formHeading").insertAdjacentHTML("afterend", responseJSON.validationSummary);
	    			window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		}
	};
	
	const showError = (msg) => {
		helpers.ClearBusyBtn();
		submitBtn.disabled = false;
		helpers.ShowErrorStatus(submitBtn, msg);
	};
	
	const showSuccess = (msg) => {
		omniture.ContactSuccess();
		helpers.ClearBusyBtn();
		submitBtn.disabled = false;
		contactForm.classList.add("hide");
		successSection.classList.remove("hide");
		const moreShopDiv = successSection.querySelector(".featHdrText");
		helpers.ShowSuccessStatus(moreShopDiv, msg);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};
	
	const failure = () => {
		helpers.ClearBusyBtn(); 
		helpers.ShowErrorStatus(submitBtn, messages.Failure);
		submitBtn.disabled = false;
	};
	
	const omniture = (function () {		
	   	const contactSuccess = () => {
	   		const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';
	    		if (s != '') {
	        		if(s.pageName) s.pageName = "Contact Form Confirmation";
	        		if(s.channel) s.channel = "Info Page";
	        		if(s.prop37) s.prop37 = "infopages/contactformconfirmation";
	        		s.t();
	       	 }
	   	 };
	
	    return {
	        ContactSuccess: contactSuccess
	    };
	}());
	
	return {
		init: init
	};
	
};

(async () => {
	const contactUsForm = new validateContactUsForm();
	contactUsForm.init();
})();